export const wide = 250;
export const narrow = 55;
